import { useForm, FormProvider } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useCreateCv } from './api'
import { formSchema } from './uploadSchema'
import FormBuilder from '../../../../components/app/formBuilder'
import { Button } from '../../../../components/common'
import { uploadCv } from './data'

interface UploadCvProps {
  data?: any
}

export default function UploadCv({ data }: UploadCvProps) {
  const methods = useForm({
    resolver: zodResolver(formSchema),
    mode: 'onChange',
  })

  const { handleSubmit } = methods
  const { mutate } = useCreateCv(onSuccess)

  function onSuccess() {
    methods.reset()
  }
  console.log(data.id)
  const onSubmit = (formValues: any) => {
    const formData = new FormData()

    if (formValues.pitch_deck_user && data?.id) {
      formData.append('pitch_deck_user', formValues.pitch_deck_user)
      formData.append('id', String(data.id)) // <-- ensure it's a string
    }
    console.log(formData)

    mutate({ formData, id: data.id })
  }
  console.log(methods.formState.errors)

  return (
    <div className="w-11/12 mx-auto py-10">
      {data.status === 'interview_scheduled' && (
        <FormProvider {...methods}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="space-y-10 bg-white p-8 rounded-lg"
          >
            <div className="mb-8">
              <h2 className="text-lg font-semibold">Upload Pitch Deck</h2>

              <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-4">
                <FormBuilder data={uploadCv} edit />
              </div>
            </div>

            <div className="flex justify-end">
              <Button
                type="submit"
                className="bg-white0 text-white px-6 py-2 rounded"
                label="Submit"
              />
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  )
}
